<template>
  <graph-detail34-template
    :board-ids="[480]"
    field-code="public-transportation"
    :com-group-list="comGroupList"
    graph1-title="전체 (공중교통수단)안전·보건 확보 의무 현황"
    graph2-title="월별 (공중교통수단)안전·보건 확보 의무 현황"
    graph3-title="기간별 (공중교통수단)안전·보건 확보 의무 현황"
    :hide-board-button="true"
    field-category-label="구분"
    field-label="공중교통수단"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail34Template from "@/views/graph-detail/GraphDetail34Template.vue";

export default {
  name: "GraphDetail73",
  components: {
    GraphDetail34Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
